import {NavigationEvent} from "./NavigationEvent";
import {EventEmitter,Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {ToolbarEvent} from "./ToolbarEvent";
import {ToolbarEventPageEnum} from "./ToolbarEvent";

/**
 * Created by oksuztepe on 09/01/17.
 */

@Injectable()
export class ToolbarService {
  public value: string;
  private eventOccuredSource:BehaviorSubject<ToolbarEvent> = new BehaviorSubject<ToolbarEvent>(new ToolbarEvent(ToolbarEventPageEnum.NONE, "", null, "", "", "", "", "", ""));

  eventOccured$ = this.eventOccuredSource.asObservable();
  // service command
  action(event: ToolbarEvent) {
    this.eventOccuredSource.next(event);
  }

  constructor() {
    this.value = "1";
  }


}
